<div
  *ngIf="featureEnabled && limit && !useHideGuard && !allowed"
  class="p-4 is-flex is-flex-direction-column is-align-items-flex-start has-background-warning-light"
>
  <span [translate]="typedDenyMessage" [translateParams]="data"></span>
  <button (click)="goToUpgrade()" class="button is-success mt-4" translate>
    common.Upgrade
  </button>
</div>
